export const DEPARTMENT_LIST = [
  'Billing / Finance',
  'Broker',
  'Category Management',
  'Executive Leadership / CEO',
  'HR',
  'IT',
  'Legal',
  'Marketing',
  'Planogram',
  'Product Data Management',
  'Sales',

];
